import { type DistributionRuleType } from 'crm-atoms/services';

export const getLeadDistributionQuery = `
query LeadDistribution($id: Int!) {
  leadDistribution(id: $id) {
    id
    defaultUser {
      userUuid
    }
    rules {
      id
      name
      criteriaGroupId
      entities {
        entity {
          ... on User {
            userUuid
          }
        }
      }
    }
  }
}
`;

export interface LeadDistributionRuleType extends DistributionRuleType {
  id: number;
}

export interface LeadDistributionType {
  id: number;
  defaultUser: {
    userUuid: string;
  };
  rules: {
    name: string;
    criteriaGroupId: string;
    entities: {
      entity: {
        userUuid: string;
      };
    }[];
  }[];
}

export interface GetLeadDistributionQueryType {
  leadDistribution: LeadDistributionType[];
}
